import { Flex, Link } from '@chakra-ui/react';
import { useState } from 'react';

import Subtitle from '../../../../components/Subtitle';
import Button from '../../../../components/ui/buttons/Button';
import { copyToClipboard } from '../../../../utils/copy';
import { buildReferralUrl } from '../../../../utils/referrals';
import { Referrer } from '../../../../utils/types/referrer';

const ReferralLink = ({
  referrer,
  setSendModalOpen,
}: {
  referrer: Referrer;
  setSendModalOpen: (val: boolean) => void;
}) => {
  const [copied, setCopied] = useState<boolean>(false);
  const handleCopy = async (code: string) => {
    const success = await copyToClipboard(
      `${buildReferralUrl({
        code,
        utms: {
          campaign: 'invite-copy',
          medium: 'referral',
        },
      })}`,
    );
    setCopied(success);
    if (success) {
      setTimeout(() => setCopied(false), 5000);
    }
  };
  return (
    <Flex flexDir="column" py={2} pt={4} borderTopWidth={1} mt={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Subtitle
          letterSpacing="1px"
          fontWeight={700}
          fontSize={15}
          textTransform="uppercase"
          m="0 !important"
        >
          Your Referral Link
        </Subtitle>
        <Flex
          justifyContent="center"
          borderRadius={3}
          bg={copied ? 'mountainGreen' : '#eee'}
          fontSize={11}
          px={1}
          fontWeight={600}
          color={copied ? '#fff' : '#222'}
          textTransform="uppercase"
          cursor={copied ? 'default' : 'pointer'}
          onClick={() => {
            if (copied || !referrer?.code) return;
            handleCopy(referrer.code);
          }}
        >
          {copied ? `Copied` : `Copy`}
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={2}>
        <Link
          mx="auto"
          fontSize={12}
          w="100%"
          fontWeight={500}
          bg="#efefef"
          mt={2}
          py={2}
          textAlign="center"
          borderRadius={3}
          href={referrer?.code ? `${buildReferralUrl({ code: referrer.code })}` : undefined}
          target="_blank"
          rel="noopener noreferrer"
        >
          {buildReferralUrl({ code: referrer.code || null })}
        </Link>
      </Flex>
      {referrer?.code && (
        <Button mt={1} w="100%" onClick={() => setSendModalOpen(true)}>
          Share
        </Button>
      )}
    </Flex>
  );
};
export default ReferralLink;
